import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import PageFooter from '../components/PageFooter';
import StockChart from '../components/StockChart';
import './PageIndustriaAnio.css';

const DATA = [
  { year: 2010, value: 209922035 },
  { year: 2011, value: 201247321 },
  { year: 2012, value: 252477775 },
  { year: 2013, value: 251502039 },
  { year: 2014, value: 283757477 },
  { year: 2015, value: 290176157 },
  { year: 2016, value: 286891278 },
  { year: 2017, value: 255110687 },
  { year: 2018, value: 217398531 },
  { year: 2019, value: 211683770 },
  { year: 2020, value: 166847531 },
  { year: 2021, value: 205863683 },
  { year: 2022, value: 193051785 },
  { year: 2023, value: 230195373 },
  { year: 2024, value: 281406806 },
  { year: 2025, value: 278372312 },
];

const EVENTS = [
  { year: 2010, label: 'Porfirio Lobo' },
  { year: 2014, label: 'JOH (1er Término)' },
  { year: 2017, label: 'JOH Anuncia Reelección' },
  { year: 2020, label: 'COVID-19' },
  { year: 2022, label: 'Xiomara Castro' },
];

function PageIndustriaDomestica() {
  const navigate = useNavigate();

  return (
    <PageBackground>
      <div className="industria-page">
        <header className="industria-header">
          <button className="btn-back" onClick={() => navigate('/industria-anio')}>
            &#8592; Industria
          </button>
          <div className="industria-title-block">
            <h1 className="industria-title">Capital Dom&eacute;stico</h1>
            <p className="industria-subtitle">Inversi&oacute;n publicitaria &middot; Anunciantes dom&eacute;sticos &middot; Honduras 2010–2025 &middot; USD</p>
          </div>
          <button className="btn-next" onClick={() => navigate('/industria-anio-transnacional')}>
            Siguiente &#8594;
          </button>
          <img src={require('../assets/logo-publisearch.png')} alt="Publisearch" className="header-logo-inline" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
        </header>

        <StockChart data={DATA} color="#4ade80" events={EVENTS} />

        <PageFooter />
      </div>
    </PageBackground>
  );
}

export default PageIndustriaDomestica;
